/**
 * The UI typeface for text drawn on a canvas (share cards, certificates).
 * Canvas text only uses a web font that is already loaded, so generators
 * call `loadCanvasFont()` first; if it can't load, the system sans is used.
 * (2026-10-05 typography pass: Space Grotesk everywhere — Segoe UI and the
 * Georgia/Cormorant italic lines on the cards went with it.)
 */
export const CANVAS_FONT = "'Space Grotesk', -apple-system, 'Segoe UI', 'Helvetica Neue', sans-serif";

export async function loadCanvasFont(): Promise<void> {
  try {
    const fonts = typeof document !== "undefined" ? document.fonts : undefined;
    if (!fonts?.load) return;
    await Promise.all(["400", "500", "600", "700"].map((w) => fonts.load(`${w} 32px 'Space Grotesk'`)));
  } catch {
    /* the system sans is fine */
  }
}
